import { node } from ".";

export const mainNodes: node[] = [
    "news",
    "govil",
    "agendas",
    "google_news",
    "committee_session",
    "plenum_session",
    "person_to_position",
    "query",
    "bill",
    "press_release",
    "gov_statisctics",
    "govil_data",
    "govil_pdf",
    "antique",
    "antique_trends",
    "news_11",
    "news_with_login",
    "iplan",
    "mavat",
    "dynamic_collector_first",
    "dynamic_collector_second",
    "dynamic_collector_third",
    "isa",
    "sg_presidium",
    "boi",
    "cs_documents",
    "mr_gov_il",
    "mr_gov_il_pdf",
    "btl_gov_il",
    "btl_news",
    "govextra_gov_il",
  ];

export const spareNodes: node[] = [
   // "kns_parser_commity_t",
   // "kns_parser_fr_commity_sessions",
   // "kns_parser_fr_news",
  //  "kns_parser_fr_commity_protocols",
   // "kns_parser_fr_commity_conclutions",
   // "kns_parser_kns_app_query",
   // "kns_parser_kns_app_agenda",
  //  "kns_parser_kns_plenumal",
    "kns_parser_kns_plenum_weekly_agenda",
  ];
